import servicesVector from "../assets/img/services-vector.png";
import "./services.css";

import Fade from "react-reveal/Fade";

const Services = () => {
  return (
    <Fade bottom>
      <div id="services" className="services-container ">
        <div className="row">
          <div className="col-md-6">
            <div className="about-title">
              <span className="color-primary font-family-class">02. </span>{" "}
              Service offers
            </div>
          </div>
        </div>
        <div className="row services">
          <div className="col-md-12 col-lg-6 services-details_container">
            <div className="services-details mb-5">
              <h5 className="services-details_title mb-3">FRONTEND APPS</h5>
              <p className="services-details_paragraph">
                Build client-side applications with modern features like SPA and
                maintain semantic coding style among other best practices for
                SEO optimization. Use modern tech such as React, TailwindCSS,
                Bootstrap and Sass
              </p>
            </div>
            <div className="services-details">
              <h5 className="services-details_title mb-3">BACKEND APPS</h5>
              <p className="services-details_paragraph">
                Build scalable and maintainable server applications using modern
                technology stacks such as Node.js, Express, Mongoose and
                MongoDB.
              </p>
            </div>
          </div>
          <div className="col-md-6 d-lg-flex services-image_container d-none align-items-center">
            <img
              src={servicesVector}
              alt="services-vector"
              className="services-image"
            />
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Services;
